import {
  CheckboxFieldContainer,
  CheckboxFormControlLabelSized,
  ErrorText,
  FieldWrapper,
} from "styles/formStyleComponents";
import Checkbox from "@mui/material/Checkbox";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import InfoIconWithTooltip from "./InfoIconWithTooltip";

const authConsentCheckboxSx = {
  flex: "0 0 auto",
  color: appThemeColors.border.strong,
  padding: "2px 0 0",
  "&.Mui-checked": {
    color: appThemeColors.text.lightBlue,
  },
};

const authConsentErrorSx = {
  marginLeft: "30px",
  marginTop: "4px",
  fontFamily: appThemeFonts.family.ui,
  fontSize: appThemeFonts.size.md,
  color: `${appThemeColors.semantic.danger} !important`,
};

const CheckboxFieldComponent = ({
  name,
  label,
  value,
  required,
  disabled,
  error,
  info,
  field = {},
  onChange,
}) => {
  const labelFontSize = field.labelFontSize;
  const authConsent = field.authConsent === true;

  return (
    <FieldWrapper compact>
      <CheckboxFieldContainer
        sx={authConsent ? { alignItems: "flex-start", gap: "10px" } : undefined}
      >
        <CheckboxFormControlLabelSized
          labelFontSize={labelFontSize}
          authConsent={authConsent}
          control={
            <Checkbox
              checked={value || false}
              onChange={(e) => onChange(name, e.target.checked)}
              disabled={disabled}
              required={required}
              size={authConsent ? "small" : "medium"}
              sx={authConsent ? authConsentCheckboxSx : undefined}
            />
          }
          label={label}
        />
        <InfoIconWithTooltip info={info} />
      </CheckboxFieldContainer>
      {error ? (
        <ErrorText error sx={authConsent ? authConsentErrorSx : undefined}>
          {error}
        </ErrorText>
      ) : null}
    </FieldWrapper>
  );
};

export default CheckboxFieldComponent;

